import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import config from "../firebaseConfig.json";
import isDevelopment from "./isDevelopment";

const firebaseConfig = config;

// Note: don't use it inside react functions. ONLY FOR INIT Firebase
const initialFirebase = () => {
    const currentApp =
        getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

    // const analytics = getAnalytics(app);

    if (isDevelopment()) {
        const auth = getAuth(currentApp);
        const functions = getFunctions(currentApp, "europe-west1");
        const db = getFirestore(currentApp);
        connectAuthEmulator(auth, "http://localhost:9099");
        connectFunctionsEmulator(functions, "localhost", 5001);
        connectFirestoreEmulator(db, "localhost", 8080);
    }
};

export default initialFirebase;
